
import api from '@/services/api'
import Router from '@/router/index';

const store = {
  namespaced: true,
  state: {
    company: null,
    name: null,
    token: null
  },
  mutations: {
    settoken (state, token) {
      state.token = token
    },
    setcompany (state, company) {
      state.company = company
    },
    setname (state, name) {
      state.name = name
    }
  },
  getters: {
    getToken: state => {
      return state.token
    }
  },
  actions: {
    logout ({commit}) {
      commit('settoken', null)
      Router.push('login')
    },
    async attemptLogin ({ commit, state }, {username, password}) {

      try {
        let call = await api.post({token: null, url: 'login', params: {username, password}});

        commit('settoken', call.token)
        commit('setcompany', call.response.company)
        commit('setname', call.response.name)
        return true;
      }catch (err) {
        // pas de réponse serveur : hors-ligne, serveur injoignable ou timeout
        if (!err.response) {
          return 'Serveur injoignable, vérifiez votre connexion';
        }

        const data = err.response.data;
        if (data && data.response && data.response.message) {
          return data.response.message;
        }
      }
      return false;
    }
  }
}

export default store